<template>
    <div>
        <!-- <el-upload
		class="upload-demo"
		ref="upload"
		action="https://jsonplaceholder.typicode.com/posts/"
		:on-preview="handlePreview"
		:on-remove="handleRemove"
		:file-list="fileList"
		:auto-upload="false">
		<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
		<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
		<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
	</el-upload>
            :auto-upload="false"
            :http-request="httpRequest"-->
        <el-upload
            ref="elUpload"
            :disabled="loadStatus"
            :multiple="true"
            :action="actionUrl"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :name="name"
            :headers="headers"
            :accept="accept"
            :before-upload="beforeUpload"
            :limit="limit"
            :on-exceed="onExceed"
            :file-list="fileList"
            :on-success="onSuccess"
            :data="otherData"
            :http-request="httpRequest"
            :show-file-list="false"
        >
            <el-button style="background-color: #1890ff;border-color: #1890ff;" slot="trigger" :loading="loadStatus" size="small" type="primary"
                >上传文件</el-button
            >
        <div v-for="(item,idx) in fileList" :key="idx" class="picHold">
            <a :href="$adddom(item.url)" target="_blank">{{ item.name }}</a>
            <i @click="filedelete(idx)" class="delete el-icon-delete"></i>
        </div>
        </el-upload>
        <div slot="tip" class="el-upload__tip">{{ tip }}</div>
        <el-dialog
            :visible.sync="dialogVisible"
            :append-to-body="true"
            style="text-align: center"
        >
            <video height="500px" width="100%" controls :src="dialogImageUrl"></video>
        </el-dialog>
    </div>
</template>
<script>
import store from "../../store";

export default {
    name: "ImageUpload",
    data() {
        return {
            loadStatus: false,
            dialogImageUrl: "",
            dialogVisible: false,
            name: "imgFile",
            listType: "picture-card",
            actionUrl: process.env.VUE_APP_BASE_API + "/upload/bigfile",
            headers: {
                Authorization: "",
            },
            otherData: {},
            accept: this.acceptType,
            limit: this.maxNumber,
            fileList: [],
        };
    },
    props: {
        imageList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        tipInfo: {
            type: String,
            default: function () {
                return "";
            },
        },
        maxNumber: {
            type: Number,
            default: function () {
                return 100;
            },
        },
        acceptType: {
            type: String,
            default: function () {
                return "*";
            },
        },
    },
    computed: {
        tip: function () {
            return this.tipInfo === ""
                ? this.$t("upload.defaultTipInfo")
                : this.tipInfo;
        },
    },
    watch: {
        imageList: function () {
            if (this.imageList.length != 0) {
                this.fileList = this.imageList;
                this.$emit('updateImg', this.fileList);
            } else {
                this.fileList = [];
                this.$emit('updateImg', this.fileList);
            }
        },
    },
    created() {
        if (this.imageList.length != 0) {
            this.fileList = this.imageList;
        } else {
            this.fileList = [];
        }
    },
    methods: {
        filedelete(val){
            this.fileList.splice(val, 1)
            this.$emit('updateImg', this.fileList);
        },
        httpRequest(params){
            let that = this
            that.loadStatus = true
            that.$forceUpdate()
            console.log(this.loadStatus)
            console.log("uploadFile", params);
            function ajax(){
                var LENGTH = 1024 * 1024 * 10; //每次上传的大小
                var totalSize = params.file.size; //文件总大小
                var start = 0; //每次上传的开始字节
                var end = start + LENGTH; //每次上传的结尾字节
                var blob = null; //二进制对象
                var fd = null; //创建表单数据对象
                var xhr = null; //xhr对象
                var response = null;
                while (start < totalSize) {
                    fd = new FormData(); //每一次需要重新创建
                    xhr = new XMLHttpRequest(); //需要每次创建并设置参数
                    xhr.open("POST", process.env.VUE_APP_BASE_API + "/upload/bigfile", false);
                    blob = params.file.slice(start, end); //根据长度截取每次需要上传的数据
                    //重新设置开始和结尾
                    // console.log(fd);
                    fd.append("video", blob); //添加数据到fd对象中
                    fd.append("filename", params.file.name); //获取文件的名称
                    if (end >= totalSize) {
                    fd.append("is_last", 1);
                    } else {
                    fd.append("is_last", 0);
                    }
                    that.loadStatus = true
                    xhr.send(fd); //将fd数据上传
                    response = JSON.parse(xhr.response);
                    if (response.code != 200) {
                        that.$message({
                            showClose: true,
                            message: '上传失败，请检查网络及上传的内容是否符合要求！',
                            type: 'warning'
                        });
                        that.loadStatus = false
                        return;
                    } 
                    start = end;
                    end = start + LENGTH;
                    // console.log('上传了文件');
                }
                that.loadStatus = false
                that.onSuccess(response)
            }
            setTimeout(function(){
                ajax()
            },300)
        },
        clearFileList() {
            this.$refs["elUpload"].clearFiles();
            this.fileList = [];
        },
        handleRemove(file, fileList) {
            this.fileList.forEach((ele, idx) => {
                if (ele.name == file.name) {
                    this.fileList.splice(idx, 1);
                }
            });
        },
        handlePictureCardPreview(file) {
            let link = document.createElement('a') // 创建a标签   实现下载  window.open(url,'_blank')
            link.style.display = 'none'
            link.setAttribute('download', '');// download属性
            link.setAttribute('href',this.$adddom(file.path));// href链接
            link.setAttribute('target', '_blank');// href链接
            document.body.appendChild(link)
            link.click();// 自执行点击事件
            document.body.removeChild(link)
            // this.dialogImageUrl = file.url;
            // this.dialogVisible = true;
        },
        beforeUpload(file) {
            let that = this
            that.loadStatus = true
            that.$forceUpdate()
            console.log(that.loadStatus)
            this.headers.Authorization = store.getters.token;
            this.otherData.language = store.getters.language;
        },
        onExceed(files, fileList) {
            this.loadStatus = false
            this.$message.warning("最多可以上传" + this.limit + "张图片");
        },
        onSuccess(response, file, fileList) {
            this.loadStatus = false
            if (response.code === 200) {
                this.fileList.push({
                    name: response.result.filename,
                    // filetype: response.result.filetype,
                    path: response.result.url,
                    url: this.$adddom(response.result.url),
                });
                this.$emit('updateImg', this.fileList);
            } else {
                this.$message.error(response.message);
                fileList.splice(
                    fileList.findIndex((item) => item.uid === file.uid),
                    1
                );
                if (
                    response.code === 50008 ||
                    response.code === 50012 ||
                    response.code === 50014
                ) {
                    store.dispatch("user/resetToken").then(() => {
                        location.reload();
                    });
                }
            }
        },
    },
};
</script>
<style scoped>
/deep/.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}
/deep/.el-button--small{
    font-size: 16px;
}
.picHold{
    position: relative;padding-right: 20px;
}
.picHold a{
    color: #1890ff;
    word-break:break-all;
}
.picHold .delete{
    color:#f00;
}
/deep/.el-upload__tip{
	color: rgba(255,255,255,0.87);
}
/deep/.el-upload-list__item-name,/deep/.el-upload-list__item-name [class^="el-icon"],/deep/.el-upload-list__item:hover .el-icon-close,/deep/.el-upload-list__item.is-success .el-upload-list__item-name:hover{
	color: rgba(255,255,255,0.87);
}
/deep/.el-upload-list__item:hover{
	background-color: rgba(91,154,250,0.75);
}
</style>
